"use client"

import { useAppSelector } from "@/lib/redux/hooks"
import { getFareRules } from "@/utils/flight/getFareRules"
import { useEffect } from "react"
import { useTranslation } from "react-i18next"
import { useIsDomestic } from "./useIsDomestic"

let refCalled: any = {}

export const useAllFareRules = () => {
  const { i18n } = useTranslation()
  const fareRules0 = useAppSelector(state => state.flight.get_fare_rules_0.data)
  const fareRules1 = useAppSelector(state => state.flight.get_fare_rules_1.data)

  const fareRules0Called = useAppSelector(state => state.flight.get_fare_rules_0.called)
  const fareRules1Called = useAppSelector(state => state.flight.get_fare_rules_1.called)

  const loading = useAppSelector(state => state.flight.get_fare_rules_1.loading ||
    state.flight.get_fare_rules_0.loading
  )

  const isDomestic = useIsDomestic()

  useEffect(() => {

    if (isDomestic && !!fareRules0Called) {
      return;
    }

    if (!isDomestic && !!fareRules1Called) {
      return;
    }

    const key = `${isDomestic ? 0 : 1}${i18n.language}`
    if (!refCalled[key]) {
      refCalled = {
        [key]: true
      }
      getFareRules({ lang: i18n.language })
    }
  }, [i18n.language, isDomestic, fareRules0Called, fareRules1Called])

  return {
    loading,
    fareRules0,
    fareRules1
  }
}